exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  overflow: hidden;\n}\n\n.contact {\n  margin-top: 20px;\n}\n\n.contact .icons {\n  margin: 0;\n}\n\n#footer {\n  margin-top: 1.5rem;\n}\n\niframe {\n  width: 100%;\n  border: none;\n}\n\ndiv.header {\n  height: 50px;\n  background: #333;\n}\n\ndiv.header h1 {\n  color: grey !important;\n  font-size: 37px;\n  display: inline;\n  vertical-align: super;\n  margin-left: 20px;\n}\n\ndiv.header a {\n  cursor: pointer;\n  border: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/manu/ArtCode/artCode/artCode/node_modules/postcss-loader/lib?{"ident":"postcss"}!/home/manu/ArtCode/artCode/artCode/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles